import React from 'react'
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu'
import type { EditMenuCommands } from '../types/menu-items'
import { DesktopCommandItem } from './desktop-command-item'
import { DesktopSubmenu } from './desktop-submenu'

type DesktopEditMenuProps = {
  commands: EditMenuCommands
  closeMenu: () => void
}

export const DesktopEditMenu: React.FC<DesktopEditMenuProps> = ({ commands, closeMenu }) => {
  return (
    <DesktopSubmenu label="Edit">
      {commands.history.map((command, index) => (
        <DesktopCommandItem key={index} command={command} closeMenu={closeMenu} />
      ))}
      <DropdownMenuSeparator />
      {commands.clipboard.map((command, index) => (
        <DesktopCommandItem key={index} command={command} closeMenu={closeMenu} />
      ))}
      <DropdownMenuSeparator />
      <DesktopCommandItem command={commands.selectAll} closeMenu={closeMenu} />
      <DesktopCommandItem command={commands.selectNone} closeMenu={closeMenu} />
      <DropdownMenuSeparator />
      <DesktopCommandItem command={commands.checkSpelling} closeMenu={closeMenu} />
      <DropdownMenuItem>Edit Dictionary</DropdownMenuItem>
    </DesktopSubmenu>
  )
}
